import { render } from "./BusLoadingAnimation.vue?vue&type=template&id=264b9956&scoped=true"
import script from "./BusLoadingAnimation.vue?vue&type=script&lang=js"
export * from "./BusLoadingAnimation.vue?vue&type=script&lang=js"

import "./BusLoadingAnimation.vue?vue&type=style&index=0&id=264b9956&scoped=true&lang=scss"
import "./BusLoadingAnimation.vue?vue&type=style&index=1&id=264b9956&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264b9956"]])

export default __exports__